import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { CampaignBreakdown } from '../../types/dashboard.types';

interface CampaignBreakdownChartProps {
  data: CampaignBreakdown[];
}

export const CampaignBreakdownChart: React.FC<CampaignBreakdownChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Campaign Breakdown</h3>
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No campaign data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Campaign Breakdown</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="campaignName"
            tick={{ fontSize: 12 }}
            angle={-15}
            textAnchor="end"
            height={80}
          />
          <YAxis yAxisId="left" tick={{ fontSize: 12 }} />
          <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 12 }} />
          <Tooltip
            formatter={(value: any, name?: string) => {
              if (name === 'Revenue ($)') {
                return `$${Number(value).toLocaleString()}`;
              }
              return value;
            }}
          />
          <Legend />
          <Bar yAxisId="left" dataKey="sales" fill="#3b82f6" name="Sales Count" />
          <Bar yAxisId="right" dataKey="revenue" fill="#10b981" name="Revenue ($)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
